__turbopack_context__.v({
  "icon": "socials-module-scss-module__hebQuW__icon",
  "socials": "socials-module-scss-module__hebQuW__socials",
});
